export var extension = function extension(fileName) {
  var _exec$, _exec;
  return (_exec$ = (_exec = /(?:\.([^.]+))?$/.exec(fileName)) === null || _exec === void 0 ? void 0 : _exec[1]) !== null && _exec$ !== void 0 ? _exec$ : '';
};